import CheckCircle from "@assets/images/check-circle.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";

const useStyle = makeStyles(
  () => ({
    checkCircleimg: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      color: "white",
      marginRight: "4px"
    },
    flex: {
      display: "flex"
    },
    formControl: {
      padding: 2
    },
    dialog: {
      width: "420px",
      height: "242px",
      padding: "32px 24px 32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    titles: {
      fontSize: "20px",
      fontWeight: 700
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "315px",
      height: "48px",
      marginTop: "30px"
    },
    buttonTitle: {
      fontSize: "18px",
      color: "white"
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px"
    }
  }),
  { name: "DialogSuccess" }
);

export interface Props {
  visible: boolean;
  onClose: () => void;
  title: string;
}

const DialogSuccess = ({ visible, onClose, title }: Props) => {
  const classes = useStyle();
  const intl = useIntl();
  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box className={classes.dialog} display="flex" flexDirection={"column"}>
        <div className={classes.checkCircleimg}>
          <img
            src={CheckCircle}
            alt="Check Circle Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography>
            {intl.formatMessage(
              {
                defaultMessage: "{title}",
                description: "title"
              },
              { title }
            )}
          </Typography>
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {intl.formatMessage({
              defaultMessage: "สำเร็จ ",
              description: "success"
            })}
            <br />
          </Typography>
        </div>

        <Button className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonTitle}>
            {intl.formatMessage({
              defaultMessage: "ดำเนินการต่อ",
              description: "Proceed Next"
            })}
          </Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogSuccess;
